import React, { useEffect, useRef, useState } from 'react';
import { Alert, Spin } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from '../../../shared/i18n';
import { accessApi } from './api';

/**
 * /access/sso?org=&host=&state= — reached from team.yeap.cloud (access-server /access/sso/v1/start).
 * Asks the API for a signed assertion and posts it back to the org's dashboard.
 */
const AccessSso = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const [error, setError] = useState('');
    const formRef = useRef(null);
    const [post, setPost] = useState(null);

    useEffect(() => {
        accessApi.sso(params.get('org') || '', params.get('host') || '', params.get('state') || '')
            .then(setPost)
            .catch((e) => setError(e.error || t('Sign-in failed')));
    }, [params, t]);

    useEffect(() => {
        if (post && formRef.current) formRef.current.submit();
    }, [post]);

    if (error) return <Alert type="error" showIcon message={error} style={{ margin: 24 }} />;
    return (
        <div style={{ padding: 48, textAlign: 'center' }}>
            <Spin tip={t('Opening dashboard…')}><div style={{ height: 48 }} /></Spin>
            {post && (
                <form ref={formRef} method="POST" action={post.action} style={{ display: 'none' }}>
                    <input type="hidden" name="assertion" value={post.assertion} />
                </form>
            )}
        </div>
    );
};

export default AccessSso;
